import * as React from 'react';
import renderDataTest from '../../utilities/testAutomation';
import InfoIcon from '../Icons/InfoIcon/InfoIcon';

const Parser = require('html-react-parser');

interface TooltipProps {
  content: string;
  dataTest?: string;
}

const Tooltip = ({
  content,
  dataTest,
}: TooltipProps) => (
  <div className="tooltip-wrapper" {...dataTest && renderDataTest(dataTest || '', 'wrapper')}>
    <div className="i-icon">
      <InfoIcon />
      <div className="popover-content" {...dataTest && renderDataTest(dataTest || '', 'content')}>
        <div className="triangle" />
        <p>{Parser(content)}</p>
      </div>
    </div>
  </div>
);

export default Tooltip;



// WEBPACK FOOTER //
// ./src/components/Tooltip/Tooltip.tsx